// extracted by mini-css-extract-plugin
export default {"nsstepview":"ns-step-view_nsstepview__MB7vi","nsstepview_icoquestion":"ns-step-view_nsstepview_icoquestion__Cjxgd"};